function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { tabbable, isFocusable, focusable } from 'tabbable';
import uniqueId from './unique_id.js';
var containerStack = new Set();

function focusTrap(container) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      abortSignal = _ref.abortSignal,
      _ref$surround = _ref.surround,
      surround = _ref$surround === void 0 ? true : _ref$surround,
      _ref$boundaries = _ref.boundaries,
      boundaries = _ref$boundaries === void 0 ? [] : _ref$boundaries;

  var controller = new AbortController();
  var signal = abortSignal || controller.signal;
  var recentlyFocused; // TODO: Remove this once ambiki migrates to dialog component.

  boundaries.forEach(function (boundary) {
    if (boundary) {
      containerStack.add(boundary);
    }
  }); // Ensure focus remains inside the container or inside one of the container stack.

  function handleFocusin(event) {
    var _a, _b;

    var target = ((_b = (_a = event.composedPath) === null || _a === void 0 ? void 0 : _a.call(event)) === null || _b === void 0 ? void 0 : _b[0]) || event.target;

    var _iterator = _createForOfIteratorHelper(containerStack),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;

        if (element.contains(target)) {
          recentlyFocused = target;
          return;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    tryFocus(recentlyFocused);
  }

  var id = uniqueId();
  container.setAttribute('data-focus-trap-id', id);
  containerStack.add(container);
  var sentinelStart = createSentinel(id);

  sentinelStart.onfocus = function () {
    var tabbableElements = tabbable(container).filter(function (element) {
      return !element.hasAttribute('data-sentinel-for');
    });
    var lastFocusableElement = tabbableElements[tabbableElements.length - 1];
    (lastFocusableElement || container).focus();
  };

  var sentinelEnd = createSentinel(id);

  sentinelEnd.onfocus = function () {
    var tabbableElements = tabbable(container).filter(function (element) {
      return !element.hasAttribute('data-sentinel-for');
    });
    var firstFocusableElement = tabbableElements[0];
    (firstFocusableElement || container).focus();
  };

  if (surround) {
    insertBefore(sentinelStart, container);
    insertAfter(sentinelEnd, container);
  } else {
    // Fix for top level popovers. Cannot insertAfter or insertBefore.
    container.prepend(sentinelStart);
    container.append(sentinelEnd);
  }

  tryFocus(getFirstFocusableElement(container));
  document.addEventListener('focusin', handleFocusin, {
    signal: signal,
    capture: true
  });
  signal.addEventListener('abort', function () {
    var _a;

    var sentinels = (_a = container.parentNode) === null || _a === void 0 ? void 0 : _a.querySelectorAll("[data-sentinel-for=\"".concat(id, "\"]"));
    sentinels === null || sentinels === void 0 ? void 0 : sentinels.forEach(function (sentinel) {
      return sentinel.remove();
    });
    container.removeAttribute('data-focus-trap-id');
    containerStack.delete(container);
    recentlyFocused = null;
  });

  function getFirstFocusableElement(container) {
    if (container.hasAttribute('data-autofocus') && isFocusable(container)) {
      return container;
    }

    var element = container.querySelector('[data-autofocus]');

    if (element && isFocusable(element)) {
      return element;
    }

    var focusableElements = focusable(container).filter(function (element) {
      return !element.hasAttribute('data-sentinel-for');
    });

    if (focusableElements[0]) {
      return focusableElements[0];
    }

    if (isFocusable(container)) {
      return container;
    }
  }

  function tryFocus(element) {
    if (!element) {
      tryFocus(container);
      return;
    }

    if (element === document.activeElement) return;
    element.focus({
      preventScroll: true
    });
    recentlyFocused = element;
  }

  return controller;
}

function createSentinel(id) {
  var sentinel = document.createElement('span');
  sentinel.setAttribute('tabindex', '0');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.setAttribute('data-sentinel-for', id);
  sentinel.style.position = 'fixed';
  sentinel.style.top = '1px';
  sentinel.style.left = '1px';
  sentinel.style.width = '1px';
  sentinel.style.height = '0px';
  sentinel.style.padding = '0px';
  sentinel.style.margin = '-1px';
  sentinel.style.overflow = 'hidden';
  sentinel.style.clip = 'rect(0px, 0px, 0px, 0px)';
  sentinel.style.whiteSpace = 'nowrap';
  sentinel.style.borderWidth = '0px';
  return sentinel;
}

function insertBefore(newNode, container) {
  var _a;

  (_a = container.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(newNode, container);
}

function insertAfter(newNode, container) {
  var _a;

  (_a = container.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(newNode, container.nextSibling);
}

export { focusTrap as default };